module.exports = __webpack_public_path__ + "static/media/ensuite-bath.f0b89677.jpg";